import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import {
  Grid,
  Paper,
  Typography,
  TextField,
  Button,
  Link as MuiLink,
} from '@material-ui/core'

import Link from '../controls/Link'
import { resetPassword, getErrorText } from '../../utils/AuthService'
import Layout from './Layout'
import ErrorView from './ErrorView'

import SmallArrowRight from '../../../assets/images/icons/ico_arrow_small.svg'

class LoginLinkExpired extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
  }

  static styles = (theme) => ({
    textFieldRoot: {
      ...theme.loginTextFieldRoot,
      margin: theme.spacing(3, 0),
    },
    promptPaper: {
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        padding: theme.spacing(3),
      },
      [theme.breakpoints.up('md')]: {
        width: 'auto',
        maxWidth: '520px',
        padding: theme.spacing(5),
      },
    },
    buttonContained: theme.buttonContained,
    link: theme.loginLink,
    email: {
      margin: theme.spacing(3, 0),
      fontWeight: 500,
    },
  })

  state = {
    email: '',
    resend: false,
    error: null,
  }

  handleError = (error) => {
    if (error) {
      this.setState({ error: { text: getErrorText(error) } })
    }
  }

  handleEmail = (e) => {
    this.setState({ email: e.currentTarget.value })
  }

  handlePasswordReset = () => {
    const { email } = this.state
    resetPassword(email, this.handleError)
    this.setState({ resend: true })
  }

  displayText() {
    const { resend } = this.state
    if (resend) {
      return {
        title: 'Check your email',
        subtitle: 'You should receive a link to your email address shortly.',
        primaryAction: 'Resend link',
        secondaryAction: 'Return to sign in',
      }
    }
    return {
      title: 'The link has expired',
      subtitle: 'We\'ll send a new link to:',
      primaryAction: 'Get a login link',
      secondaryAction: 'Return to sign in',
    }
  }

  renderEmail() {
    const { classes } = this.props
    const { email, resend } = this.state
    if (resend) {
      return (
        <Typography variant="h5" className={classes.email}>{email}</Typography>
      )
    }
    return (
      <TextField
        autoComplete="on"
        classes={{ root: classes.textFieldRoot }}
        fullWidth
        placeholder="Email"
        variant="outlined"
        type="email"
        onChange={this.handleEmail}
      />
    )
  }

  render() {
    const { classes } = this.props
    const { error } = this.state
    const displayText = this.displayText()

    if (error) {
      return (
        <Layout>
          <Paper elevation={3} square classes={{ root: classes.promptPaper }}>
            <ErrorView error={error} />
          </Paper>
        </Layout>
      )
    }

    return (
      <Layout>
        <Paper elevation={3} square classes={{ root: classes.promptPaper }}>
          <Typography variant="h1">{displayText.title}</Typography>
          <Typography variant="h2">{displayText.subtitle}</Typography>
          {this.renderEmail()}
          <Grid container justify="space-between" alignItems="center">
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                onClick={this.handlePasswordReset}
                classes={{ contained: classes.buttonContained }}
              >
                {displayText.primaryAction}
                <img src={SmallArrowRight} alt="→" />
              </Button>
            </Grid>
            <Grid item>
              <MuiLink component={Link} to="/login" className={classes.link}>
                {displayText.secondaryAction}
              </MuiLink>
            </Grid>
          </Grid>
        </Paper>
      </Layout>
    )
  }
}

export default withStyles(LoginLinkExpired.styles)(LoginLinkExpired)
